
import { IGenerateRequestParam, IVariateRequestParam, IRedeemRequestParam, ICreatePromoRequestParam, ICanvaLoginRequestParams, ICreatePaymentIntentResponse, IConvertToSvgOnlyRequestParam, ICreatePaymentIntentRequestParams, IRedeemResponse, IJoinAffiliateResponse, ICreatePromoResponse, IGeneratePixelRequestParam, ICopyStyleRequestParam, ICreateCanvaPaymentIntentRequestParams } from "./apiTypes";
import { getAuth } from "firebase/auth";

import { setErrorAction } from "./store/actions/ui";
import { Dispatch } from "redux";

const BASE_URL = import.meta.env.VITE_BASE_URL;
const GENERATOR_URL = import.meta.env.VITE_GENERATOR_URL;
const FIREBASE_FUNCTIONS_URL = import.meta.env.VITE_FIREBASE_FUNCTIONS_URL;

let authenticatedPostRequestRepeat = true;

const authenticatedPostRequest = async (token: string, path: string, body: any, dispatch?: Dispatch) => {
  if (token) {
    try {
      const response = await fetch(`${BASE_URL}${path}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        },
        body: JSON.stringify(body)
      });

      if ((response.status === 403) && authenticatedPostRequestRepeat) {
        authenticatedPostRequestRepeat = false;
        const newToken = await getAuth().currentUser?.getIdToken();
        if (newToken) {
          const promise: any = authenticatedPostRequest(newToken, path, body);
          return promise
        } else {
          if(dispatch){
            dispatch(setErrorAction("Your session has expired. Refresh the page or login again."));
          }
          return { success: false }
        }
      }

      if (response.status === 200) {
        authenticatedPostRequestRepeat = true;
        return response.json();
      } else {
        return { success: false }
      }
    } catch (error) {
      return { error, success: false }
    }
  }
}

const unauthenticatedPostRequest = async (body: any, path: string) => {
  try {
    const response = await fetch(`${FIREBASE_FUNCTIONS_URL}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    });

    if (response.status === 200) {
      return response.json();
    } else {
      return { success: false }
    }
  } catch (error) {
    return { error, success: false }
  }
}

export const generateApi = async (token: string, body: IGenerateRequestParam) => {
  try {
    const response = await fetch(`${GENERATOR_URL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify(body)
    });
    return response.json();
  } catch (error) {
    return
  }
}

export const copyStyleApi = async (token: string, body: ICopyStyleRequestParam) => {
  try {
    const response = await fetch(`${GENERATOR_URL}/copy`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify(body)
    });
    return response.json();
  } catch (error) {
    return
  }
}

export const variateApi = async (token: string, body: IVariateRequestParam) => {
  try {
    const response = await fetch(`${GENERATOR_URL}/variation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify(body)
    });
    if(response.status !== 200){
      throw new Error("Failed to create variation");
    } 
    return response.json();
  } catch (error) {
    return
  }
}

export const redeemApi = async (token: string, body: IRedeemRequestParam) => {
  return authenticatedPostRequest(token, '/app/redeem', body) as Promise<IRedeemResponse>;
}

export const joinAffiliateApi = async (token: string) => {
  return authenticatedPostRequest(token, '/app/joinAffiliate', {}) as Promise<IJoinAffiliateResponse>;
}

export const createPromoApi = async (token: string, body: ICreatePromoRequestParam) => {
  return authenticatedPostRequest(token, '/app/createPromo', body) as Promise<ICreatePromoResponse>;
}

export const createPaymentIntentApi = async (token: string, body: ICreatePaymentIntentRequestParams) => {
  return authenticatedPostRequest(token, '/app/createPaymentIntent', body) as Promise<ICreatePaymentIntentResponse>;
}

export const createCanvaPaymentIntentApi = async (body: ICreateCanvaPaymentIntentRequestParams) => {
  return unauthenticatedPostRequest(body, '/canvaAppExternal/createPaymentIntent') as Promise<ICreatePaymentIntentResponse>;
}

export const createApiKeyApi = async (token: string) => {
  return authenticatedPostRequest(token, '/app/createApiKey', {});
}

export const deleteApiKeyApi = async (token: string) => {
  return authenticatedPostRequest(token, '/app/deleteApiKey', {});
}

export const canvaLoginApi = async (token: string, body: ICanvaLoginRequestParams) => {
  return authenticatedPostRequest(token, '/app/canvaLogin', body);
}

export const convertToSvgOnlyApi = async (token: string, body: IConvertToSvgOnlyRequestParam) => {
    try {
    const response = await fetch(`${GENERATOR_URL}/trace`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify(body)
    });
    return response.json();
  } catch (error) {
    return
  }
}

export const generatePixelApi = async (token: string, body: IGeneratePixelRequestParam) => {
  try {
    const response = await fetch(`${GENERATOR_URL}/pixel`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify(body)
    });
    return response.json();
  } catch (error) {
    return
  }
}
